/**
 * サイドメニューコンテキスト
 * 
 * @file SideMenuContext.tsx
 * @version 1.0.0
 * @author Japan4U Development Team
 * @summary
 * アプリケーション全体でサイドメニューの開閉状態を共有するためのContext
 */

import React, { createContext, useContext, useState } from 'react';

interface SideMenuContextType {
  sideMenuOpen: boolean;
  toggleSideMenu: () => void;
  closeSideMenu: () => void;
}

const SideMenuContext = createContext<SideMenuContextType | undefined>(undefined);

export const useSideMenu = () => {
  const context = useContext(SideMenuContext);
  if (!context) {
    throw new Error('useSideMenu must be used within a SideMenuProvider');
  }
  return context;
};

export const SideMenuProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [sideMenuOpen, setSideMenuOpen] = useState(false);

  const toggleSideMenu = () => {
    setSideMenuOpen(!sideMenuOpen);
  };

  const closeSideMenu = () => {
    setSideMenuOpen(false);
  };

  return (
    <SideMenuContext.Provider value={{ sideMenuOpen, toggleSideMenu, closeSideMenu }}>
      {children}
    </SideMenuContext.Provider>
  );
};
